module.exports = __webpack_public_path__ + "img/ess_gold.f9e91756.png";